import React from 'react';
import { ContentGrid, Row, Col, theme } from '@ovotech/element-v5';
import ChargeAnytimePlans, {
  Variant,
} from '@/src/pages/Offers/components/cards/ChargeAnytimePlans/ChargeAnytimePlans';
import { PlanDetails } from '@monovo/ev-anytime';
import { Media } from '@/src/components/Media';
import { breakpoints } from '@/src/utils/mediaQuery';
import styled from 'styled-components';

interface PlanGridProps {
  plans: PlanDetails[];
  ctaText: string;
  onCtaClick: (planId: string) => void;
  variant: Variant;
}

const showMultipleEvsBadge = (plan: PlanDetails) => {
  return 'multipleEvs' in plan.features;
};

const HorizontalScrollContainer = styled.div`
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  gap: ${theme.space['350']};
`;

const StyledContentGrid = styled(ContentGrid)`
  padding-inline: 0;
`;

export const PlanGrid: React.FC<PlanGridProps> = ({
  plans,
  ctaText,
  onCtaClick,
  variant,
}) => (
  <div style={{ padding: theme.space['0'] }}>
    <Media query={breakpoints.mediumUp}>
      <StyledContentGrid>
        <Row isNested style={{ gap: theme.space['600'] }}>
          {plans.map((plan: PlanDetails, index: number) => (
            <Col
              key={plan.id}
              medium={6}
              style={{
                marginBottom:
                  index < Object.values(plans).length - 1
                    ? theme.space['200']
                    : theme.space['0'],
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <ChargeAnytimePlans
                plan={plan}
                ctaText={ctaText}
                onCtaClick={() => onCtaClick(plan.id)}
                data-testid={`plan-card-${plan.id}`}
                showMultipleEvsBadge={showMultipleEvsBadge(plan)}
                variant={variant}
                useSolidCta
                hideMultipleEvsFeature
              />
            </Col>
          ))}
        </Row>
      </StyledContentGrid>
    </Media>
    <Media query={breakpoints.mediumDown}>
      <HorizontalScrollContainer>
        {plans.map((plan: PlanDetails) => (
          <ChargeAnytimePlans
            key={plan.id}
            plan={plan}
            ctaText={ctaText}
            onCtaClick={() => onCtaClick(plan.id)}
            data-testid={`plan-card-${plan.id}`}
            showMultipleEvsBadge={showMultipleEvsBadge(plan)}
            variant={variant}
            useSolidCta
            hideMultipleEvsFeature
          />
        ))}
      </HorizontalScrollContainer>
    </Media>
  </div>
);
